export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Medium.ecb7297b.otf";